import * as React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';

import { ReadAloudSource } from '../../../Shared/components/readAloud/readAloudSource';
import { CLIP_SOURCE_TYPE, clipSource } from '../../../Shared/libs/speech/clipSource';
import { AnswerTextEditor, Feedback, FeedbackStatements, SentenceFragments, getDisplayedText, getLatestAttempt, renderPreviewFeedback, Cues, } from '../../../Shared/index';
import { cancelSpeech } from '../../../Shared/libs/speech/speechManager';
import staticStrings from '../../../Shared/libs/speech/staticStrings.json';
import { storeResponseInAttempts, } from '../../actions/diagnostics.js';
import { getGradedResponsesWithCallback, saveResponseToCMS } from '../../actions/responses.js';
import { ENGLISH } from '../../../Shared/utils/languageList';
import getResponse from '../../libs/checkDiagnosticSentenceCombiningQuestionAnswer';
import { generateStyleObjects } from '../../libs/markupUserResponses';
import C from '../../constants';

class ELLSentenceCombining extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      editing: false,
      response: '',
      readyForNext: false,
    }
  }

  componentDidMount = () => {
    getGradedResponsesWithCallback(
      this.getQuestion().key,
      (data) => {
        this.setState({ responses: data, });
      }
    );
  }

  removePrefilledUnderscores = () => {
    this.setState(prevState => ({ value: prevState.response.replace(/_/g, '') }))
  }

  getQuestion = () => {
    const { question, } = this.props;
    if (question.key.endsWith('-esp')) {
      question.key = question.key.slice(0, -4);
    }
    return question;
  }

  getResponses = () => {
    const { responses, } = this.state
    return responses;
  }

  getResponse2(rid) {
    return this.getResponses()[rid];
  }

  renderSentenceFragments = () => {
    return <SentenceFragments prompt={this.getQuestion().prompt} />;
  }

  listCuesAsString(cues) {
    const newCues = cues.slice(0);
    return `${newCues.splice(0, newCues.length - 1).join(', ')} or ${newCues.pop()}.`;
  }

  getErrorsForAttempt(attempt) {
    return _.pick(attempt, ...C.ERROR_TYPES);
  }

  renderCues = () => {
    const { diagnosticID, language, translate, languageLocale } = this.props
    const question = this.getQuestion();
    return (
      <Cues
        diagnosticID={diagnosticID}
        displayArrowAndText
        includeReadAloudButton
        language={language}
        languageLocale={languageLocale}
        question={question}
        translate={translate}
      />
    );
  }

  updateResponseResource = (response) => {
    const { dispatch, } = this.props
    const attempts = this.getQuestion().attempts;
    const latestAttempt = attempts[attempts.length - 1];
    const isFirstAttempt = !latestAttempt;
    dispatch(saveResponseToCMS(response.response, isFirstAttempt));
  }

  handleSubmitResponse = (e) => {
    const { editing, responses, response, } = this.state
    const { marking, diagnosticID, dispatch, } = this.props

    if (editing && responses) {
      this.removePrefilledUnderscores();
      const submittedResponse = getResponse(this.getQuestion(), response, this.getResponses(), marking || 'diagnostic');
      this.updateResponseResource(submittedResponse);
      if (submittedResponse.response && submittedResponse.response.author === 'Missing Details Hint' && diagnosticID !== 'ell') {
        this.setState({
          editing: false,
          error: 'Your answer is too short. Please read the directions carefully and try again.',
        });
      } else {
        dispatch(storeResponseInAttempts(submittedResponse));
        this.setState({
          editing: false,
          response: '',
          error: undefined,
        }, this.handleNextQuestionClick);
      }
    }
  }

  toggleDisabled = () => {
    const { editing, } = this.state

    return editing ? '' : 'disabled'
  }

  handleChange = (e) => {
    this.setState({ editing: true, response: e, });
  }

  readyForNext = () => {
    const { question, previewMode } = this.props
    if (question.attempts.length > 0) {
      const latestAttempt = getLatestAttempt(question.attempts);
      if (previewMode && latestAttempt) {
        return true;
      } else if (latestAttempt.found) {
        const errors = _.keys(this.getErrorsForAttempt(latestAttempt));
        if (latestAttempt.response.optimal && errors.length === 0) {
          return true;
        }
      }
    }
    return false;
  }

  getProgressPercent = () => {
    const { question, } = this.props
    return question.attempts.length / 3 * 100;
  }

  finish = () => {
    this.setState({ finished: true, });
  }

  handleNextQuestionClick = () => {
    const { nextQuestion, previewMode, isLastQuestion } = this.props
    cancelSpeech();
    this.setState({ response: '', });
    // we don't submit the last question if in previewMode
    if(previewMode && isLastQuestion) { return }
    nextQuestion();
    this.setState({ response: '', });
  }

  renderNextQuestionButton(correct) {
    if (correct) {
      return (<button className="button is-outlined is-success" onClick={this.handleNextQuestionClick} type="button">Siguiente</button>);
    }
    return (<button className="button is-outlined is-warning" onClick={this.handleNextQuestionClick} type="button">Siguiente</button>);
  }

  renderMedia = () => {
    if (this.getQuestion().mediaURL) {
      return (
        <div style={{ marginTop: 15, minWidth: 200, }}>
          <img alt={this.getQuestion().mediaAlt} src={this.getQuestion().mediaURL} />
        </div>
      );
    }
  }

  renderError = () => {
    const { languageLocale } = this.props
    const { error, } = this.state
    if (!error) { return }

    return (
      <div className="error-container">
        <Feedback
          feedbackText={error}
          feedbackType="revise-unmatched"
          languageLocale={languageLocale}
        />
      </div>
    )
  }

  renderButton = () => {
    const { responses } = this.state;
    const { previewMode, language, question, translate, languageLocale } = this.props;
    const latestAttempt = getLatestAttempt(question.attempts);
    const buttonText = language ? translate('buttons^submit') : 'Submit';

    if((previewMode && latestAttempt) || !responses) {
      return <button className="quill-button focus-on-light large green contained disabled" lang={languageLocale} type="button">Submit</button>;
    }
    if (question.attempts && question.attempts.length > 0) {
      return <button className="quill-button focus-on-light large green contained" lang={languageLocale} onClick={this.handleNextQuestionClick} type="button">{buttonText}</button>;
    } else {
      return <button className="quill-button focus-on-light large green contained" lang={languageLocale} onClick={this.handleSubmitResponse} type="button">{buttonText}</button>;
    }
  }

  renderFeedback = () => {
    const { language, previewMode, question, translate, languageLocale } = this.props;
    const { key } = question;
    const latestAttempt = getLatestAttempt(question.attempts);
    const questionInstructions = this.getQuestion().instructions;
    const instructions = (questionInstructions && questionInstructions !== '') ? questionInstructions : staticStrings['connect.defaultInstructions'];
    if(previewMode && latestAttempt && latestAttempt.response) {
      return renderPreviewFeedback(latestAttempt);
    }
    if(!language || language === ENGLISH) {
      return(
        <Feedback
          feedbackHtml={instructions}
          feedbackType="default"
          key={key}
          languageLocale={languageLocale}
        />
      );
    }
    return(
      <Feedback
        feedbackText={instructions}
        feedbackType="default"
        key={key}
        language={language}
        languageLocale={languageLocale}
        translatedFeedbackText={translate(`instructions^${instructions}`)}
      />
    );
  }

  render = () => {
    const { question, previewMode } = this.props
    const { error, response } = this.state
    const fullPageInstructions = { maxWidth: 800, width: '100%', }
    const displayedText = getDisplayedText({ previewMode, question, response });

    if (question) {
      return (
        <ReadAloudSource source={clipSource(CLIP_SOURCE_TYPE.QUESTION, question.key)}>
          <div className="student-container-inner-diagnostic">
            <div style={{ display: 'flex', justifyContent: 'spaceBetween', }}>
              <div style={fullPageInstructions}>
                {this.renderSentenceFragments()}
                {this.renderCues()}
                {this.renderFeedback()}
              </div>
              {this.renderMedia()}
            </div>
            <AnswerTextEditor
              disabled={this.readyForNext()}
              errorTypes={C.ERROR_TYPES}
              generateStyleObjects={generateStyleObjects}
              getResponse={this.getResponse2}
              hasError={error}
              onChange={this.handleChange}
              onSubmitResponse={this.handleSubmitResponse}
              placeholder="Type your answer here."
              surface="textarea"
              value={displayedText}
            />
            {this.renderError()}
            <div className="question-button-group button-group">
              {this.renderButton()}
            </div>
          </div>
        </ReadAloudSource>
      );
    }
    return (<p>Loading...</p>);
  }
}

function select(state) {
  return {
    concepts: state.concepts,
    questions: state.questions,
  };
}

export default connect(select)(ELLSentenceCombining);
